import PropTypes from 'prop-types'
import { useState } from 'react'

import UnstyledButton from '@thebeansgroup/ui_ctas/unstyled_button'
import ChevronIconThin from '@thebeansgroup/ui_icons/chevron_icon_thin'

import { ACCORDION_CONTENT, CLOSE } from './constants'
import * as styles from './styles'

const Accordion = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div>
      <UnstyledButton
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls={ACCORDION_CONTENT}
        css={styles.button(isOpen)}
      >
        {title}
        <ChevronIconThin
          rotateDegrees={isOpen ? 180 : 0}
          label={CLOSE}
        />
      </UnstyledButton>

      <div
        id={ACCORDION_CONTENT}
        hidden={!isOpen}
        css={styles.content}
        data-testid={ACCORDION_CONTENT}
      >
        {children}
      </div>
    </div>
  )
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
}

export default Accordion
